__turbopack_context__.v({
  "className": "futurapt_8c7859f9-module__JuDRkq__className",
  "variable": "futurapt_8c7859f9-module__JuDRkq__variable",
});
